export default {
  mortgage: {
    get: "/mortgage"
  },
  products: {
    get: "/products"
  },
  search: {
    search: "/search"
  },
  forms: {
    get: "/forms",
    getiframe: "/form",
    clone: "/forms/clone",
    multiple: "/propositioneditor",
    multipleUpdate: "/propositioneditor/update"
  },
  submit: {
    get: "/submits",
    post: "/submits"
  },
  widgets: {
    get: "/widget"
  },
  iframe: {
    post: "/form/submit"
  },
  suppliers: {
    get: "/suppliers"
  },
  translations: {
    get: "/translation"
  },
  default: {
    checkpostcode: "/postcode",
    checkziggo: "/availability/ziggo",
    checktmobile: "/availability/tmobile",
    checkyoufone: "/availability/youfone",
    checkkpn: "/availability/kpn",
    clients: "/clients",
    countries: "/countries",
    // durations: "/propositions",
    checkDuration: "/check_duration",
    getrates: "/rates",
    getconsumptionlist: "/consumption",
    getsolarlist: "/solar",
    login: "/login",
    logout: "/logout"
  },
  users: {
    get: "/users",
    post: "/users",
    reset: "/reset-password"
  },
  pages: {
    getPageByName: "/pages"
  },
  editable: {
    column: '/edit-column'
  }
};
